// src/pages/Home.tsx
import { useNavigate } from "react-router-dom";
import "./Home.css";
import logoCongelcam from "../assets/congelcam-logo.png"; // chemin vers ton logo

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      {/* Logo centré */}
      <img src={logoCongelcam} alt="Logo Congelcam" className="logo-congelcam" />

      <h1 className="title">Bienvenu(e) sur SuiviCongelcam</h1>
      <p className="subtitle">Quel type d'utilisateur êtes-vous ?</p>

      <div className="auth-options">
        <button
          className="btn-superadmin"
          onClick={() => navigate("/login-superadmin")}
        >
          🔑SuperAdmin
        </button>

        <button
          className="btn-user"
          onClick={() => navigate("/login-user")}
        >
          👤Utilisateur simple
        </button>
      </div>
    </div>
  );
}
